import React from "react";
import { Link } from 'react-router-dom';
import CompanyConst from '../company-const';


const CompanyInfoField = ({ company }) => <Link to={ `${ CompanyConst.basePath }/${ company.id }` }> { company.title }</Link>

export default CompanyInfoField;